import React, { useCallback, useContext, useEffect, useState } from 'react'
import { makeStyles } from '@material-ui/core/styles'
import styles from '../../styles'
import { ProfileModel, UpdateProfileModel } from './profileModel'
import { convertPostProfile, convertProfile } from './profileMapper'
import Loader from '../../components/loader/Loader'
import NotFound from '../../components/notfound/NotFound'
import { FormattedMessage, useIntl } from 'react-intl'
import { ClassValue } from 'classnames/types'
import classNames from 'classnames'
import Link from '../../components/link/Link'
import DisplayInfo from './components/DisplayInfo'
import { useMediaQuery } from 'react-responsive'
import { ContractsModel } from '../../types/contracts/contractsModel'
import { paymentsMode, PRL_AUTO } from '../../enums/contractsEnum'
import Dialog from '../../components/dialog/Dialog'
import CloseIcon from '@material-ui/icons/Close'
import PersonalForm from './components/PersonalForm'
import { RootState } from '../reducers'
import { connect, useDispatch } from 'react-redux'
import { isEmailOk, isPasswordOk, isPhoneOk } from '../../utils/formUtils'
import IconButton from '@material-ui/core/IconButton'
import fetchFactory from '../../utils/fetchFactory'
import { FORM_ERROR } from 'final-form'
import { displaySnackbar } from '../reducers/snackBar/actions'
import { UPDATE_INFO } from '../../enums/profileEnum'
import SwitchField from '../../components/fields/SwitchField'
import RadioField from '../../components/fields/RadioField'
import languages from '../../enums/languagesEnum'
import { displayModal } from '../reducers/modal/actions'
import { modalTypes } from '../../enums/modalTypeEnum'
import Button from '../../components/button/Button'
import { RequestItemModel } from '../requests/requestsModel'
import { subCategoryEnum } from '../../enums/makeRequestEnum'
import errorCatcher from '../../utils/errorCatcher'
import { saveInteractions } from '../gtm/utils/gtmCallback'
import portals from '../../enums/portalsEnum'
import logout from '../../api/logout'
import { useCookies } from 'react-cookie'
import { Grid } from '@material-ui/core'
import { PrelevementContext } from './prelevement/PrelevementContext'
import { saveUser } from '../reducers/user/actions'
import localStorageEnum from '../../enums/localStorageEnum'
import { UserModel } from '../../types/user/userModel'

const PROFILE_COMPONENT = 'profile'

const PREFERENCES_KEY = {
	ERELEVE: 'ereleve',
	LANGUAGE: 'language',
	EMAIL: 'hasAcceptedEmail',
	SMS: 'hasAcceptedSMS',
	FOLLOW_EMAIL: 'followEmail'
}

const PREFERENCES_GROUP_KEY = {
	EMAIL: 'hasAcceptedEmailGroup',
	SMS: 'hasAcceptedSMSGroup'
}

const POLITIQUE_CONFIDENTIALITE_GECINA_URL = 'https://www.gecina.fr/fr/donnees-personnelles'
const POLITIQUE_CONFIDENTIALITE_YOUFIRST_URL = 'https://youfirst.co/politique-de-protection-des-donnees-personnelles/'

const useStyle = makeStyles(
	(theme) => (
		{
			...styles(theme),
			profilePage: {
				background: 'white',
				marginBottom: 16,
				paddingTop: 50
			},
			paddingProfileSmall: {
				paddingLeft: 15
			},
			paddingProfileLarge: {
				paddingLeft: 75
			},
			titleAccountSmallContainer: {
				alignItems: 'center'
			},
			titleAccountLargeContainer: {
				alignItems: 'flex-start'
			},
			accountContainerSmallScreen: {
				marginLeft: 10,
				marginRight: 10,
				paddingBottom: 35
			},
			accountContainerLargeScreen: {
				marginLeft: 35,
				paddingBottom: 35
			},
			subtitle: {
				marginTop: 50
			},
			eReleveDescStyle: {
				marginTop: 10,
				textAlign: 'justify'
			},
			eReleveFieldStyle: {
				marginTop: 56
			},
			languageLabelStyle: {
				marginTop: 80,
				marginBottom: 40
			},
			subscriptionStyle: {
				marginTop: 30,
				marginBottom: 20
			},
			icon: {
				position: 'absolute',
				top: 10,
				right: 12
			},
			imgTitle: {
				marginRight: 25
			},
			dialogContainerLargeScreen: {
				margin: '10px 20px 10px 20px'
			},
			dialogContainerSmallScreen: {
				margin: 10
			},
			youfirstInformationsTitleStyle: {
				fontSize: 18,
				fontFamily: '\'Montserrat\', sans-serif',
				lineHeight: '1.33',
				color: theme.palette.blue.main,
				marginTop: 20,
				marginBottom: 20,
				fontWeight: 700
			},
			prelevementBtn: {
				marginTop: 20,
				width: 'fit-content'
			},
			youfirstInformationsInfoStyle: {
				...styles(theme).text8,
				marginTop: 20
			},
			youfirstInformationsSecondInfoStyle: {
				...styles(theme).text8,
				fontWeight: 400,
				marginTop: 20
			},
			followEmailTextStyle: {
				...styles(theme).text8,
				fontWeight: 400
			},
			followEmailLiensStyle: {
				...styles(theme).text8,
				fontWeight: 400,
				marginTop: 10,
				marginBottom: 10
			},
			lienExterne: {
				display: 'block',
				width: 'fit-content',
				color: 'inherit',
				textDecoration: 'underline',
				// Lien déjà souligné : pas de barre animée au survol
				'&::before': {
					display: 'none'
				}
			}
		}
	)
)

interface Store {
	contracts: ContractsModel[],
	requests: RequestItemModel[],
}

type ProfileProps = Store

const ProfilePage: React.FC<ProfileProps> = (
	{
		contracts,
		requests
	}
) => {
	const { prelevement } = useContext(PrelevementContext)
	const [profile, setProfile] = useState<ProfileModel | null>(null)
	const [loading, setLoading] = useState<boolean>(true)
	const [openDialog, setOpenDialog] = useState<boolean>(false)
	const [updateInformation, setUpdateInformation] = useState<string>('')
	const classes = useStyle()
	const intl = useIntl()
	const dispatch = useDispatch()
	const removeCookies = useCookies()[2]

	const handleDialog = (open: boolean = false, updateInfo: string = '') => {
		setOpenDialog(open)
		setUpdateInformation(open ? updateInfo : '')
	}

	const isLargeScreen = useMediaQuery(
		{
			query: '(min-width: 1025px)'
		}
	)

	const getUserDetails = useCallback(() => {
		fetchFactory(`/api/ec_${process.env.REACT_APP_TARGET}/utilisateur/details`)
			.then((res: any) => {
				if (res && res.length) {
					setProfile(convertProfile(res[0]))
				}
			})
			.catch(e => setProfile(null))
			.finally(() => setLoading(false))
	}, [])

	useEffect(() => {
		getUserDetails()
	}, [getUserDetails])

	const profileClass: ClassValue = classNames(
		classes.profilePage,
		isLargeScreen ? classes.paddingProfileLarge : classes.paddingProfileSmall
	)

	const titleClass: ClassValue = classNames(
		'col-xs-12 col-md-9 row',
		isLargeScreen ? classes.titleAccountLargeContainer : classes.titleAccountSmallContainer,
		classes.colorBlue,
		isLargeScreen ? classes.title1 : classes.title2
	)
	const accountContainerClass: ClassValue = classNames(
		'col-xs-12 col-md-9 row',
		isLargeScreen ? classes.accountContainerLargeScreen : classes.accountContainerSmallScreen
	)
	const subTitleClass: ClassValue = classNames(
		'col-xs-12',
		classes.colorAccessibility,
		isLargeScreen ? classes.title2 : classes.title3,
		classes.subtitle
	)
	const eReleveFieldClass: ClassValue = classNames(
		'col-xs-12',
		classes.eReleveFieldStyle,
		classes.colorBlue
	)
	const eReleveDescClass: ClassValue = classNames(
		'col-xs-12',
		classes.text3,
		classes.eReleveDescStyle,
		classes.colorBlue
	)
	const languageClass: ClassValue = classNames(
		'col-xs-12',
		classes.title8,
		classes.languageLabelStyle,
		classes.colorBlue
	)
	const linkClass: ClassValue = classNames(
		'col-xs-12'
	)
	const dialogClass: ClassValue = classNames(
		'row',
		isLargeScreen ? classes.dialogContainerLargeScreen : classes.dialogContainerSmallScreen
	)
	const dialogTitle: ClassValue = classNames(
		'col-xs-12',
		classes.colorAccessibility,
		classes.title2
	)
	const dialogIcon: ClassValue = classNames(
		classes.icon
	)

	const prelevementBtnClass: ClassValue = classNames(
		'col-xs-12',
		classes.prelevementBtn
	)

	const subscriptionStyle: ClassValue = classNames(
		classes.text1,
		classes.colorBlue,
		'col-xs-12',
		classes.subscriptionStyle,
		classes.semiBold
	)

	if (loading) {
		return <Loader />
	}

	if (!profile) {
		return <NotFound />
	}

	const onSubmit = (values: UpdateProfileModel) => {
		const body = JSON.stringify(convertPostProfile(values))

		return fetchFactory(`/api/ec_${process.env.REACT_APP_TARGET}/utilisateur/updateUser`, {
			method: 'PUT',
			body
		})
			.then(() => {
				dispatch(
					displaySnackbar(
						{
							id: PROFILE_COMPONENT,
							message: intl.formatMessage(
								{
									id: 'profile.success',
									defaultMessage: 'L\'actualité demandée n\'a pas été trouvé',
									description: 'Error message'
								}
							),
							open: true,
							hideIcon: true
						}
					)
				)

				// Si nous venons de modifier le mail, on déconnecte l'utilisateur pour rafraichir son token avec le nouveau mail
				if (updateInformation === UPDATE_INFO.EMAIL) {
					logout(removeCookies)
				} else {
					getUserDetails()
				}
				if (!!values.phone) {
					prelevement.personalInfo.phone = values.phone
					let userLocal = localStorage.getItem(localStorageEnum.user)
					if (!!userLocal) {
						let user: UserModel = JSON.parse(userLocal)
						user.phone = values.phone
						dispatch(
							saveUser(user)
						)
						localStorage.setItem(localStorageEnum.user, JSON.stringify(user))
					}
				}
				setOpenDialog(false)
			})
			.catch(e => {
				return {
					[FORM_ERROR]: intl.formatMessage({
						...e,
						description: 'Submission error'
					})
				}
			})
	}

	const validate = (values: UpdateProfileModel) => {
		const errors: any = {}

		if (updateInformation === UPDATE_INFO.EMAIL) {
			if (!values.email) {
				errors.email = intl.formatMessage(
					{
						id: 'global.errors.required',
						defaultMessage: 'Requis*',
						description: 'Required message'
					}
				)
			} else {
				if (!isEmailOk(values.email)) {
					errors.email = intl.formatMessage(
						{
							id: 'global.errors.formatEmail',
							defaultMessage: 'Format du courriel incorrect',
							description: 'Format mail error'
						}
					)
				}
				if (!values.confirmEmail) {
					errors.confirmEmail = intl.formatMessage(
						{
							id: 'global.errors.required',
							defaultMessage: 'Requis*',
							description: 'Required message'
						}
					)
				} else if (values.confirmEmail !== values.email) {
					errors.confirmEmail = intl.formatMessage(
						{
							id: 'global.errors.notSameEmail',
							defaultMessage: 'Le courriel saisi et sa confirmation sont différents',
							description: 'Not same email error'
						}
					)
				}
			}
		} else if (updateInformation === UPDATE_INFO.PASSWORD) {
			if (values.previousPassword && !values.password) {
				errors.password = intl.formatMessage(
					{
						id: 'global.errors.required',
						defaultMessage: 'Requis*',
						description: 'Required message'
					}
				)
			}

			if (values.password) {
				if (!isPasswordOk(values.password)) {
					errors.password = intl.formatMessage(
						{
							id: 'global.errors.formatPassword',
							defaultMessage: 'Le mot de passe doit comporter au moins 8 caractères dont au moins un chiffre, une lettre minuscule et une lettre majuscule',
							description: 'Format password error'
						}
					)
				}
				if (!values.previousPassword) {
					errors.previousPassword = intl.formatMessage(
						{
							id: 'global.errors.required',
							defaultMessage: 'Requis*',
							description: 'Required message'
						}
					)
				}
			}
		} else {
			if (!values.phone && !!profile.phone) {
				errors.phone = intl.formatMessage(
					{
						id: 'global.errors.required',
						defaultMessage: 'Requis*',
						description: 'Required message'
					}
				)
			}

			if (values.phone && values.phone !== profile.phone) {
				if (!isPhoneOk(values.phone)) {
					errors.phone = intl.formatMessage(
						{
							id: 'global.errors.formatPhone',
							defaultMessage: 'Le numéro de téléphone ne doit pas faire plus de 20 caractères',
							description: 'Format Phone Error'
						}
					)
				}
			}
		}

		return errors
	}

	const handlePreferences = (key: string, value: any) => {
		// On set immédiatement la valeur pour plus de fluidité
		const oldValue = profile[key as keyof ProfileModel]
		setProfile({
			...profile,
			[key]: value
		})
		return fetchFactory(`/api/ec_${process.env.REACT_APP_TARGET}/utilisateur/updatePreferences`, {
			method: 'PUT',
			body: JSON.stringify({
				oldEmail: profile.email,
				[key]: value
			})
		})
			.catch(() => {
				// En cas d'erreur, on remet l'ancienne valeur
				setProfile({
					...profile,
					[key]: oldValue
				})

				dispatch(
					displaySnackbar(
						{
							id: 'profile.update_preferences',
							message: intl.formatMessage(
								{
									id: 'profile.errors.preferences',
									defaultMessage: 'Une erreur est survenue lors de la modification des préférences',
									description: 'Error message'
								}
							),
							open: true,
							hideIcon: true
						}
					)
				)
			})
	}

	const filteredContracts = contracts.filter((contract: ContractsModel) => !!contract.typeDePaiement)

	return <div className={profileClass}>
		<div className={titleClass}>
			<img
				src="img/profile.svg"
				alt="Profile icon"
				id="accountCircle"
				width={50}
				className={classes.imgTitle}
			/>
			<FormattedMessage
				id="profile.title"
				defaultMessage="Votre profil"
				description="Account title"
			/>
		</div>

		<div className={accountContainerClass}>
			<div className={subTitleClass}>
				<FormattedMessage
					id="profile.personalInfo"
					defaultMessage="Vos informations personnelles"
					description="Personal information subtitle"
				/>
			</div>
			<div className="col-xs-12">
				<DisplayInfo
					label={intl.formatMessage(
						{
							id: 'profile.email',
							defaultMessage: 'Courriel',
							description: 'Email information'
						}
					)}
					value={profile.email}
				/>
			</div>
			<div className={linkClass}>
				<Link
					textStyle="text8"
					color="colorAccessibility"
					onClick={() => handleDialog(true, UPDATE_INFO.EMAIL)}
				>
					<FormattedMessage
						id="profile.modify"
						defaultMessage="Modifier"
						description="Update information"
					/>
				</Link>
			</div>
			<div className="col-xs-12">
				<DisplayInfo
					label={intl.formatMessage(
						{
							id: 'profile.password',
							defaultMessage: 'Mot de passe',
							description: 'Password information'
						}
					)}
					value="**************"
				/>
			</div>
			<div className={linkClass}>
				<Link
					textStyle="text8"
					color="colorAccessibility"
					onClick={() => handleDialog(true, UPDATE_INFO.PASSWORD)}
				>
					<FormattedMessage
						id="profile.modify"
						defaultMessage="Modifier"
						description="Update information"
					/>
				</Link>
			</div>
			<div className="col-xs-12">
				<DisplayInfo
					label={intl.formatMessage(
						{
							id: 'profile.phone',
							defaultMessage: 'Téléphone mobile',
							description: 'Phone information'
						}
					)}
					value={profile.phone || ''}
				/>
			</div>
			<div className={linkClass}>
				<Link
					textStyle="text8"
					color="colorAccessibility"
					onClick={() => handleDialog(true, UPDATE_INFO.PHONE)}
				>
					<FormattedMessage
						id="profile.modify"
						defaultMessage="Modifier"
						description="Update information"
					/>
				</Link>
			</div>
			{filteredContracts.length > 0 && <div className={subTitleClass}>
				<FormattedMessage
					id="profile.payments"
					defaultMessage="Vos moyens de paiement"
					description="Payment subtitle"
				/>
			</div>}

			{filteredContracts.map((contract: ContractsModel) =>
				<div key={`contract-${contract.id}`} className="col-xs-12">
					<DisplayInfo
						label={intl.formatMessage(
							{
								id: 'profile.paymentLabel',
								defaultMessage: 'Moyen de paiement',
								description: 'Payment label'
							},
							{
								numero: contract.lease,
								lot: contract.lots.join(', '),
								address: contract.buildings && contract.buildings.length > 0
									? `${contract.buildings[0].address} ${contract.buildings[0].postalCode} ${contract.buildings[0].city}`.toUpperCase()
									: contract.address
							}
						)}
						value={intl.formatMessage(
							{
								id: `enums.paymentsMode.${paymentsMode[contract.typeDePaiement as keyof typeof paymentsMode]}`,
								defaultMessage: 'Mode de paiement',
								description: 'Payment mode'
							}
						)}
					/>
				</div>
			)}
			{filteredContracts.filter(contract => contract.typeDePaiement !== PRL_AUTO).length > 0 &&
				(
					requests.filter(request => request.category === subCategoryEnum.bill.debit && !request.cloture).length > 0 ?
						<div className={subscriptionStyle}>
							<span>
								<FormattedMessage
									id="profile.subscriptionPaymentInProgress"
									defaultMessage="Votre demande de passage au prélèvement automatique est en attente de confirmation par votre gestionnaire."
									description="Subscription in progress"
								/>
							</span>
						</div>
						:
						<div>
							<div className={subscriptionStyle}>
								<span>
									<FormattedMessage
										id="profile.paymentDesc"
										defaultMessage="Afin de simplifier vos règlements, YouFirst vous propose de souscrire au prélèvement automatique pour vos contrats."
										description="Subscription suggestion"
									/>
								</span>
							</div>
							<div className={prelevementBtnClass}>
								<Button
									background="backgroundBlue"
									color="colorWhite"
									textStyle="text8"
									onClick={() => {
										saveInteractions(
											{
												category: 'Mes Services',
												action: 'Souscrire en ligne',
												label: 'Mes Services::Souscrire en ligne::call to action'
											}
										)

										dispatch(displayModal(modalTypes.prelevement))
									}}
								>
									<FormattedMessage
										id="profile.prelevement.button"
										defaultMessage="Passer au prélèvement"
										description="Prelevement button"
									/>
								</Button>
							</div>
						</div>
				)
			}

			<div className={subTitleClass}>
				<FormattedMessage
					id="profile.preferences"
					defaultMessage="Vos préférences"
					description="Preferences subtitle"
				/>
			</div>
			<div className={eReleveFieldClass}>
				<SwitchField
					label={intl.formatMessage(
						{
							id: 'profile.eReleve',
							defaultMessage: 'SOUSCRIPTION E-RELEVÉ',
							description: 'E-releve field'
						}
					)}
					value={profile.ereleve}
					onChange={(value) => handlePreferences(PREFERENCES_KEY.ERELEVE, value)}
				/>
			</div>
			<div className={eReleveDescClass}>
				<FormattedMessage
					id="profile.eReleveDesc"
					defaultMessage="Une notification par courriel vous sera envoyée à chaque dépôt d'un nouveau document comptable sur votre Espace Client. Vous aurez la possibilité de le consulter et de le télécharger au besoin. Si vous souhaitez les recevoir également par courrier, veuillez décocher cette case."
					description="e-releve description"
				/>
			</div>
			<Grid container item xs={12}>
				<Grid item xs={12} className={classes.youfirstInformationsTitleStyle}>
					{process.env.REACT_APP_TARGET !== portals.residence ?
						<FormattedMessage
							id="profile.youfirstInformations.infoTitleCampus"
							defaultMessage="Informations YouFirst Campus"
							description="YouFirst information title"
						/>
						:
						<FormattedMessage
							id="profile.youfirstInformations.infoTitleResi"
							defaultMessage="Informations YouFirst Residence"
							description="YouFirst information title"
						/>
					}
				</Grid>

				<Grid container item xs={12}>
					<Grid item xs={4}>
						<SwitchField
							label={intl.formatMessage(
								{
									id: 'profile.youfirstInformations.email.label',
									defaultMessage: 'COURRIEL',
									description: 'Email field'
								}
							)}
							value={profile.hasAcceptedEmail}
							onChange={(value) => handlePreferences(PREFERENCES_KEY.EMAIL, value)}
						/>
					</Grid>

					<Grid item xs={4}>
						<SwitchField
							label={intl.formatMessage(
								{
									id: 'profile.youfirstInformations.sms.label',
									defaultMessage: 'SMS',
									description: 'sms field'
								}
							)}
							value={profile.hasAcceptedSMS}
							onChange={(value) => handlePreferences(PREFERENCES_KEY.SMS, value)}
						/>
					</Grid>
				</Grid>

				<Grid item xs={12} className={classes.youfirstInformationsInfoStyle}>
					<FormattedMessage
						id="profile.youfirstInformations.infoMessage"
						defaultMessage="Vous recevrez des informations de votre future résidence."
						description="YouFirst information info"
					/>
				</Grid>
			</Grid>
			{
				(profile.type === 'contact' || profile.hasSigner) && <div className={'col-xs-12'}>
					<div className={classes.youfirstInformationsTitleStyle}>
						{process.env.REACT_APP_TARGET !== portals.residence ?
							<FormattedMessage
								id="profile.youfirstInformations.titleCampus"
								defaultMessage="Actualités YouFirst Campus"
								description="YouFirst information title"
							/>
							:
							<FormattedMessage
								id="profile.youfirstInformations.titleResi"
								defaultMessage="Actualités YouFirst Residence"
								description="YouFirst information title"
							/>
						}
					</div>

					<div className={'row'}>
						<div className={'col-xs-6 col-md-4'}>
							<SwitchField
								label={intl.formatMessage(
									{
										id: 'profile.youfirstInformations.email.label',
										defaultMessage: 'COURRIEL',
										description: 'Email field'
									}
								)}
								value={profile.hasAcceptedEmailGroup}
								onChange={(value) => handlePreferences(PREFERENCES_GROUP_KEY.EMAIL, value)}
							/>
						</div>

						<div className={'col-xs-6 col-md-4'}>
							<SwitchField
								label={intl.formatMessage(
									{
										id: 'profile.youfirstInformations.sms.label',
										defaultMessage: 'SMS',
										description: 'sms field'
									}
								)}
								value={profile.hasAcceptedSMSGroup}
								onChange={(value) => handlePreferences(PREFERENCES_GROUP_KEY.SMS, value)}
							/>
						</div>
					</div>

					<div className={classes.youfirstInformationsInfoStyle}>
						<FormattedMessage
							id="profile.youfirstInformations.info"
							defaultMessage="Les actualités de votre résidence portent sur la vie dans l'immeuble et notre relation. Une notification par courriel vous sera envoyée à chaque publication d’une nouvelle actualité sur votre Espace Client."
							description="YouFirst information info"
						/>
					</div>

					<div className={classes.youfirstInformationsSecondInfoStyle}>
						<FormattedMessage
							id="profile.youfirstInformations.secondInfo"
							defaultMessage="Si vous décochez la réception des emails et/ou sms, vous continuerez à recevoir les informations liées à la vie du bail : coupure d'eau, panne ascenseur, etc"
							description="YouFirst information info"
						/>
					</div>
				</div>
			}
			{
				profile.type === 'contact' && <>
					<div className={languageClass}>
						<FormattedMessage
							id="profile.followEmail.label"
							defaultMessage="Suivi de l'ouverture de mes e-mails"
							description="Follow email field"
						/>
					</div>
					<div className={classNames('col-xs-12', classes.followEmailTextStyle, classes.colorBlue)}>
						<FormattedMessage
							id="profile.followEmail.text"
							defaultMessage="Mes données personnelles seront utilisées et partagées conformément à la Politique de confidentialité et YouFirst utilise des pixels de suivi, afin de mesurer mes interactions avec les communications qui me sont adressées et d'en améliorer la pertinence."
							description="Follow email consent text"
						/>
					</div>
					<div className={classNames('col-xs-12', classes.followEmailLiensStyle, classes.colorBlue)}>
						<a
							className={classes.lienExterne}
							href={POLITIQUE_CONFIDENTIALITE_GECINA_URL}
							target="_blank"
							rel="noopener noreferrer"
						>
							<FormattedMessage
								id="profile.followEmail.lienGecina"
								defaultMessage="Politique de confidentialité Gecina"
								description="Gecina privacy policy link"
							/>
						</a>
						<a
							className={classes.lienExterne}
							href={POLITIQUE_CONFIDENTIALITE_YOUFIRST_URL}
							target="_blank"
							rel="noopener noreferrer"
						>
							<FormattedMessage
								id="profile.followEmail.lienYoufirst"
								defaultMessage="Politique de confidentialité YouFirst"
								description="YouFirst privacy policy link"
							/>
						</a>
					</div>
					<div className="col-xs-12">
						<RadioField
							name="followEmail"
							items={[
								{
									value: 'true',
									label: intl.formatMessage(
										{
											id: 'profile.followEmail.accept',
											defaultMessage: 'J\'accepte',
											description: 'Follow email accept option'
										}
									)
								},
								{
									value: 'false',
									label: intl.formatMessage(
										{
											id: 'profile.followEmail.refuse',
											defaultMessage: 'Je refuse',
											description: 'Follow email refuse option'
										}
									)
								}
							]}
							// Aucun choix coché tant que le contact ne s'est pas prononcé
							value={typeof profile.followEmail === 'boolean' ? String(profile.followEmail) : ''}
							textStyle="text1"
							textColor="colorBlue"
							textWeight="medium"
							margin
							rowDirection
							onChange={(value) => handlePreferences(PREFERENCES_KEY.FOLLOW_EMAIL, value === 'true')}
						/>
					</div>
				</>
			}
			<div className={languageClass}>
				<FormattedMessage
					id="profile.language"
					defaultMessage="Langue dans laquelle YouFirst échange avec vous"
					description="Language field"
				/>
			</div>
			<div className="col-xs-12">
				<RadioField
					name="language"
					items={Object.keys(languages).map((lang: string) => ({
						value: lang,
						label: intl.formatMessage(
							{
								id: `enums.languages.${lang}`,
								defaultMessage: `Langue ${lang}`,
								description: 'Languages options'
							}
						)
					}))}
					value={profile.language}
					textStyle="text1"
					textColor="colorBlue"
					textWeight="medium"
					margin
					rowDirection
					onChange={(value) => handlePreferences(PREFERENCES_KEY.LANGUAGE, value)}
				/>
			</div>
		</div>
		{updateInformation !== '' && <Dialog
			onCloseDialog={handleDialog}
			open={openDialog}
			fullScreen={!isLargeScreen}
		>
			<div className={dialogClass}>
                    <span className={dialogTitle}>
                        <FormattedMessage
	                        id={`profile.modify${updateInformation}`}
	                        defaultMessage="Modifier vos coordonnées"
	                        description="Update personal info"
                        />
                    </span>
				<div className={dialogIcon}>
					<IconButton onClick={() => handleDialog()}>
						<CloseIcon />
					</IconButton>
				</div>

				<PersonalForm
					onCloseDialog={handleDialog}
					onSubmit={onSubmit}
					validate={validate}
					updateInformation={updateInformation}
					initialValues={{
						previousEmail: profile.email,
						email: profile.email,
						confirmEmail: '',
						previousPassword: '',
						password: '',
						phone: profile.phone || ''
					}}
				/>
			</div>
		</Dialog>}
	</div>
}

const mapStateToProps = (state: RootState) => (
	{
		contracts: state.contracts,
		user: state.user,
		requests: state.requests
	}
)

const mapDispatchToProps = {
	errorCatcher
}

export default connect(mapStateToProps, mapDispatchToProps)(ProfilePage)
